import { AnyObject, FieldMap, InfoStage, PopulatedAssessment } from '@hb/shared'
import { createContext } from 'react'

export interface FormContextProps {
  onSave: (() => Promise<AnyObject | undefined>) | (() => void)
  goToNext: () => void
  goToPrev: () => void
  activeStageId?: string
  activeStage?: FieldMap | InfoStage
  prevStageId?: string
  prevStage?: FieldMap | InfoStage
  nextStageId?: string
  nextStage?: FieldMap | InfoStage
  populatedAssessment?: PopulatedAssessment
  canSubmit: boolean
  isDirty: boolean
  submitLoading: boolean
  submittedOn?: number
}
export default createContext<FormContextProps>({
  onSave: () => {},
  goToNext: () => {},
  goToPrev: () => {},
  activeStageId: undefined,
  activeStage: undefined,
  prevStageId: undefined,
  prevStage: undefined,
  nextStageId: undefined,
  nextStage: undefined,
  populatedAssessment: undefined,
  canSubmit: false,
  isDirty: false,
  submitLoading: false,
  submittedOn: undefined,
})
